import { render, staticRenderFns } from "./ModalDeleteTask.vue?vue&type=template&id=550a656c&scoped=true"
import script from "./ModalDeleteTask.vue?vue&type=script&lang=js"
export * from "./ModalDeleteTask.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteTask.vue?vue&type=style&index=0&id=550a656c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a656c",
  null
  
)

export default component.exports